import { Status } from "../Entities/Subscription";
import { InvoiceAPIResponse } from "../Interface";
import apiClient from "./api.client.service";
class SubscriptionClass {
  private readonly APIBaseUrl: string;

  constructor() {
    this.APIBaseUrl = process.env.REACT_APP_API_BASE_URL ?? "";
  }

  async getInvoices(): Promise<InvoiceAPIResponse[]> {
    try {
      const responses = await apiClient.get(
        `${this.APIBaseUrl}/admin/subscription/invoices`
      );
      return responses.data;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  async checkSubscriptionStatus(
    subscriptionId: string,
    status: Status
  ): Promise<boolean> {
    try {
      const response = await apiClient.get(
        `${this.APIBaseUrl}/admin/subscription/check/${subscriptionId}?status=${status}`
      );
      return response.data;
    } catch (error) {
      console.error(
        "🚀 ~ SubscriptionClass ~ checkSubscriptionStatus ~ error:",
        error
      );
      return false;
    }
  }

  async getSubscriptionByStatus(status: Status) {
    try {
      const response = await apiClient.get(
        `${this.APIBaseUrl}/admin/subscription/filter/by?status=${status}`
      );
      return response.data;
    } catch (error) {
      console.error(
        "🚀 ~ SubscriptionClass ~ getSubscriptionByStatus ~ error:",
        error
      );
    }
  }

  async cancelSubscription() {
    try {
      const response = await apiClient.post(
        `${this.APIBaseUrl}/admin/subscription/cancel`
      );
      return response.data;
    } catch (error: any) {
      console.error(
        "🚀 ~ SubscriptionClass ~ cancelSubscription ~ error:",
        error
      );
      return {
        status: false,
        message:
          error?.response?.data?.message || "Failed to cancel subscription",
        data: null,
      };
    }
  }

  async getCurrentAccess() {
    try{
      const response = await apiClient.get(
        `${this.APIBaseUrl}/admin/subscription/current/access`
      );
      return response.data;
    }catch(error:any){
      console.error(
        "🚀 ~ SubscriptionClass ~ getCurrentAccess ~ error:",
        error
      );
      return null;
    }
  }
}
const SubscriptionService = new SubscriptionClass();

export default SubscriptionService;
